import { Utm } from '@store/dadosPessoaisSlice/type'
import { SimulacaoResponse } from '@store/simulacaoSlice/type'

import { BaseServices } from './BaseService'
import { HttpMethod, TResponseType } from './types'

export default async (data: PostSimulacao): Promise<TResponseType<SimulacaoResponse>> => {
  const headers = {
    'Content-Type': 'application/json',
    'token-captcha': data.token,
    'x-inter-origem': 'CP_ANTECIPACAO_FGTS_SITE',
  }

  const pathname = process.env.REACT_APP_POST_SIMULACAO
  const method = HttpMethod.POST
  const host = process.env.REACT_APP_HOST

  const response = BaseServices.request<SimulacaoResponse>({
    headers,
    pathname,
    method,
    host,
    data,
  })
  return response
}

export interface PostSimulacao {
  nome: string
  cpf: string
  dataNascimento: Date | undefined
  telefone: string
  email: string
  token: string
  utm: Utm
  autorizaContato: boolean
  saldoFgts: number
}
